import request from "helpers/api_helper";
import { toast } from "react-toastify";

export const getPostcodes = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `postcodes${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch postcodes");
    return error;
  }
};

export const deletePostcode = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `postcodes/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Postcode deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete postcode");
    return error;
  }
};

export const updatePostcodesBulk = async (data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `postcodes`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Postcodes updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update postcodes");
    return error;
  }
};
